import _ from "lodash";
import DP_ACTIONS from "../actions/DataProviderActions";


const initialState = {
    dataProvider: {
        provider_detail: {
            provider_id: "",
            provider_name: "",
            monthly_aggregate_volume: null,
        },
        approvals: {
            id: "",
            resource_id: "",
            is_approved: false,
            approved_on: null,
            approved_by: ""
        },
        contact_information: [
            {
                id: "",
                resource_id: "",
                type: "Business",
                name: "",
                email: "",
                phone_number: ""
            },
            {
                id: "",
                resource_id: "",
                type: "Technical",
                name: "",
                email: "",
                phone_number: ""
            }
        ]
    },
    associatedServices: [],
    deleteDPWarning: false,
}

const providerDetailReducer = (state = initialState, action) => {
    switch (action.type) {

        case DP_ACTIONS.Detail.LOAD_PROVIDER_DETAIL: {
            let newState = _.cloneDeep(state);
            newState.dataProvider = action.payload.providerDetail;
            newState.associatedServices = action.payload.providerDetail.associated_services;
            newState.associatedServices.forEach(service => {
                if (service.associated_countries !== null) {
                    service.associated_countries = service.associated_countries.split(",");
                }
            });
            return newState;
        }

        case DP_ACTIONS.Detail.CLEAR_DP_DETAIL_PAGE: {
            return initialState;
        }

        case DP_ACTIONS.Detail.DELETE_DP_WARNING:
            let newState = _.cloneDeep(state);
            newState.deleteDPWarning = !newState.deleteDPWarning;
            return newState;

        default:
            return state;
    }
}

export default providerDetailReducer;
